import { StarRating } from '@ria-client/tw-shared-ui';
import type { NodeProps } from '../types';

export function SCStarRating({ props }: NodeProps<{ rating?: number }>) {
  // Legacy SC StarRating (StructuredContentRenderer/components/StarRating): 19px stars,
  // 5px gap, marginRight 5px + marginY 3px. mr-[5px]=5px, my-[3px]=3px.
  return <StarRating className="mr-[5px] my-[3px]" gap="5px" size="19px" value={props.rating} />;
}
